import {SignInButton, SignedIn, SignedOut} from "@clerk/clerk-react";
import {Navbar} from 'flowbite-react';
import {useState} from "react";
import CustomButton from "../../../components/common/CustomButton";
import {isProductionEnv} from "../../../utils/envUtils";

const Header = ({onlyLogo=false}) => {
  const [showNavBar,setShowNavbar] = useState(false)
  const hideLogin = isProductionEnv()

  const handleToggleNavbar = () =>{
    setShowNavbar(!showNavBar)
  }

  return (
    <Navbar theme={{inner:{base:" flex gap-5 xs:flex-col relative"}}} fluid rounded className="!bg-black z-40 border-b border-gray-700 rounded-b-2xl sticky top-0">
      <div className="w-full flex flex-row justify-between items-center gap-4 md:px-12 md:py-4">
        <div className="flex flex-row gap-4 items-center justify-center">
          <Navbar.Toggle className="ml-auto block md:hidden" aria-controls="basic-navbar-nav" onClick={handleToggleNavbar} />
          <a href="/" className="flex items-center">
            <img src="https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/cadencelogo.webp" className="mr-3 h-6 md:h-9" alt="Flowbite React Logo" />
            <div className="text-center">
              <span className="text-blue-700 text-xl font-semibold font-['Inter']">Cadence</span>
              <span className="text-blue-800 text-xl font-semibold font-['Inter']">pro</span>
            </div>
          </a>
        </div>
        <div className="hidden  md:flex flex-row items-center justify-center gap-6 md:pr-20">
          <div className="text-white text-sm font-medium font-['Inter'] leading-tight cursor-pointer hover:text-blue-500">
            <a href="/pricing">Pricing</a>
          </div>
          <div className="text-white text-sm font-medium font-['Inter'] leading-tight cursor-pointer hover:text-blue-500">
            <a href="/about">About</a>
          </div>
          <div className="text-white text-sm font-medium font-['Inter'] leading-tight cursor-pointer hover:text-blue-500">
            <a href="/book-a-demo">Contact Sales</a>
          </div>
        </div>
        {!onlyLogo && (
          <div>
            <SignedIn>
              <a href="/workitems">
                <CustomButton
                  className="whitespace-nowrap bg-primary-light hover:bg-primary-hover px-4 py-2 shadow-sm hover:shadow-md transition-all
                        duration-200 text-white md:!w-full !rounded-full font-semibold font-['Work Sans'] text-lg xs:text-xs"
                >
                  <span>Dashboard</span>
                </CustomButton>
              </a>
            </SignedIn>
            {!hideLogin && (
              <SignedOut>
                <SignInButton
                  afterSignInUrl="/workitems"
                  afterSignUpUrl="/signup"
                  mode='modal'
                >
                  <CustomButton
                    className="whitespace-nowrap bg-primary-light hover:bg-primary-hover px-4 py-2 shadow-sm hover:shadow-md transition-all
                          duration-200 text-white md:!w-full !rounded-full font-semibold font-['Work Sans'] text-lg xs:text-xs"
                  >
                    <span>Login</span>
                  </CustomButton>
                </SignInButton>
              </SignedOut>
            )}
          </div>
        )}
      </div>

      {showNavBar && (
        <div className="absolute top-[60px] left-0 w-full h-fit bg-black">
          <div className="justify-start items-center gap-4 p-2 inline-flex">
            <div className="flex-col justify-start items-start gap-0.5 inline-flex">
              <div className="py-2 text-white text-sm font-medium font-['Inter'] leading-tight cursor-pointer hover:text-blue-500">
                <a href="/pricing">Pricing</a>
              </div>
              <div className="py-2 text-white text-sm font-medium font-['Inter'] leading-tight cursor-pointer hover:text-blue-500">
                <a href="/about">About</a>
              </div>
              <div className="py-2 text-white text-sm font-medium font-['Inter'] leading-tight cursor-pointer hover:text-blue-500">
                <a href="/book-a-demo">Contact Sales</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </Navbar>
  )
}

export default Header;